import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { EPlantStatus } from "../../../shared/oversight-core/enums/plant-status";
import { RootState } from "../../store";

type Site = {
  siteViewTabId: number;
  selectPlantStatus: EPlantStatus | undefined;
  isHideErrorStatus: boolean;
  isHideActiveAndOfflineStatus: boolean;
};

const initialState: Site = {
  siteViewTabId: 1,
  selectPlantStatus: undefined,
  isHideErrorStatus: false,
  isHideActiveAndOfflineStatus: false,
};

export const siteSlice = createSlice({
  name: "station",
  initialState: { ...initialState },
  reducers: {
    setSiteViewTabId: (state, action: PayloadAction<number>) => {
      state.siteViewTabId = action.payload;
    },
    setSelectPlantStatus: (
      state,
      action: PayloadAction<EPlantStatus | undefined>
    ) => {
      state.selectPlantStatus = action.payload;
    },
    setIsHideErrorStatus: (state, action: PayloadAction<boolean>) => {
      state.isHideErrorStatus = action.payload;
    },
    setIsHideActiveAndOfflineStatus: (
      state,
      action: PayloadAction<boolean>
    ) => {
      state.isHideActiveAndOfflineStatus = action.payload;
    },
  },
});

export const {
  setSiteViewTabId,
  setSelectPlantStatus,
  setIsHideErrorStatus,
  setIsHideActiveAndOfflineStatus,
} = siteSlice.actions;

export const siteViewTabId = (state: RootState) => state.sites.siteViewTabId;
export const selectPlantStatus = (state: RootState) =>
  state.sites.selectPlantStatus;
export const isHideErrorStatus = (state: RootState) =>
  state.sites.isHideErrorStatus;
export const isHideActiveAndOfflineStatus = (state: RootState) =>
  state.sites.isHideActiveAndOfflineStatus;
export default siteSlice.reducer;
